// https://codesandbox.io/s/l7y53n0k0z
import React, { forwardRef, useEffect, useRef, useState } from 'react'
import styled, { css } from '../utils/styled'

import useDebounce from '../hooks/useDebounce'

const Textarea = forwardRef((props, ref) => {
	const textareaRef = useRef(ref)

	const [value, setValue] = useState(props.value)
	const debouncedValue = useDebounce(value, 100)

	useEffect(() => {
		props.onChange(debouncedValue)
	}, [debouncedValue])

	return (
		<textarea ref={textareaRef} {...props} value={value} onChange={e => setValue(e.target.value)} />
	)
})

export default styled(Textarea)`
	-webkit-appearance: none;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: 1.2;

	padding: 8px 16px;
	padding-right: 32px;
	width: 100%;
  border-radius: 3px;
  border: 1px solid ${props => props.theme.colors.grey300};
  background-color: ${props => props.theme.colors.white};
  ::placeholder {
    color: ${props => props.theme.colors.grey300};
  }
  ${props => props.withError && css`
    border-color: ${props.theme.colors.error};
  `}
  &:focus {
    outline: 0;
    box-shadow: 0 0 0 3px ${props => props.theme.colors.primary200};
    border: 1px solid ${props => props.theme.colors.primary400};
  }
`
